import { Action, handleActions } from 'redux-actions'
import { getCompanyEmployeesSuccess, getSpecificCompanyDashboardSuccess } from './DashboardActions'
import { CompanyId, Stats } from '../../../services/api.types'

class State {
  companyDashboard: Stats[] = []
  employees: { [companyId: CompanyId]: number } = {}
}

export const dashboard = handleActions<State, any>(
  {
    [String(getSpecificCompanyDashboardSuccess)]: (state: State, { payload }): State => ({
      ...state,
      companyDashboard: payload,
    }),
    [String(getCompanyEmployeesSuccess)]: (state: State, action: Action<any>): State => ({
      ...state,
      employees: {
        ...state.employees,
        [action.payload.companyId]: action.payload.employees,
      },
    }),
  },
  new State(),
)

export { State as DashboardState }
